module.exports = __webpack_public_path__ + "img/Yoga2.d1be6817.png";